// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__607Ee","content":"LayoutSettings_content__3vCHZ"};